/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Reading_Rate_LabelInputs */

const en_summary_reading_rate_label = /** @type {(inputs: Summary_Reading_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Rate`)
};

const fr_summary_reading_rate_label = /** @type {(inputs: Summary_Reading_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taux de lecture`)
};

const de_summary_reading_rate_label = /** @type {(inputs: Summary_Reading_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesegeschwindigkeit`)
};

const it_summary_reading_rate_label = /** @type {(inputs: Summary_Reading_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocità di lettura`)
};

const ru_summary_reading_rate_label = /** @type {(inputs: Summary_Reading_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скорость чтения`)
};

const es_summary_reading_rate_label = /** @type {(inputs: Summary_Reading_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de lectura`)
};

const zh_cn2_summary_reading_rate_label = /** @type {(inputs: Summary_Reading_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读速度`)
};

const ja_summary_reading_rate_label = /** @type {(inputs: Summary_Reading_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読書速度`)
};

const hi_summary_reading_rate_label = /** @type {(inputs: Summary_Reading_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पठन दर`)
};

const pt_pt2_summary_reading_rate_label = /** @type {(inputs: Summary_Reading_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de leitura`)
};

/**
* | output |
* | --- |
* | "Reading Rate" |
*
* @param {Summary_Reading_Rate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_reading_rate_label = /** @type {((inputs?: Summary_Reading_Rate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Reading_Rate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_summary_reading_rate_label(inputs)
	if (locale === "de") return de_summary_reading_rate_label(inputs)
	if (locale === "it") return it_summary_reading_rate_label(inputs)
	if (locale === "ru") return ru_summary_reading_rate_label(inputs)
	if (locale === "es") return es_summary_reading_rate_label(inputs)
	if (locale === "zh-CN") return zh_cn2_summary_reading_rate_label(inputs)
	if (locale === "ja") return ja_summary_reading_rate_label(inputs)
	if (locale === "hi") return hi_summary_reading_rate_label(inputs)
	if (locale === "pt-PT") return pt_pt2_summary_reading_rate_label(inputs)
	return en_summary_reading_rate_label(inputs)
});